import { warn } from '@execonline-inc/logging';
import { assertNever } from '@kofno/piper';
import { currentUserStore } from '../../../../CurrentUserStore';
import ReactionComponent from '../../../../ReactionComponent';
import LearningCollectionStore from '../Store';
import { LearningCollectionState } from '../Types';
import create from './Create';
import loadForNew from './LoadForNew';
import reloadLearningDesigns from './ReloadLearningDesigns';
import reloadAllExperiences from './ReloadAllExperiences';

export interface Props {
  store: LearningCollectionStore;
}

class LearningCollectionReactions extends ReactionComponent<
  LearningCollectionStore,
  LearningCollectionState,
  Props
> {
  tester = () => this.props.store.state;
  effect = (state: LearningCollectionState) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'waiting':
        break;
      case 'loading':
        loadForNew(currentUserStore.links, store);
        break;
      case 'ready':
        store.choosingProductLicense();
        break;
      case 'choosing-product-license':
      case 'building':
        break;
      case 'creating':
        create(store, state, state.fileData);
        break;
      case 'load-error':
        warn('Could not load the learning collection:', JSON.stringify(state.error));
        break;
      case 'new-form-submission-error':
        warn('Could not save the learning collection:', JSON.stringify(state.error));
        break;
      case 'reload-all-experiences':
        reloadLearningDesigns(store, state.selectedProductLicense, state.initialProductLicense);
        reloadAllExperiences(store, currentUserStore.links, state);
        break;
      default:
        assertNever(state);
    }
  };
}

export default LearningCollectionReactions;
